import React from 'react';
import { Image, View } from 'react-native';

import {
  Button,
  useNormalize,
  useTheme,
  unboaredTheme,
  transparency,
  Text,
  space,
  ButtonProps,
  base_color,
} from '@unboared/base-ui.all';

/**
 * A button used in forms.
 */
export const ExtraSignInButton = (props: any) => {
  const { normalize } = useNormalize();
  const theme = useTheme();
  const currentTheme = theme || unboaredTheme.default;

  return (
    <Button
      {...props}
      preset="secondary"
      style={[
        {
          borderWidth: normalize(2),
          borderColor: transparency(currentTheme.mode, 0.2),
          minHeight: normalize(35),
          color: base_color.light_tertiary,
        },
        props.style || {},
      ]}
      textStyle={{ color: currentTheme.currentPalette.c200 }}
    />
  );
};

type ExtraSignInButtonWithLogoProps = ButtonProps & {
  /* The path to the logo */
  logo: string;

  /* The size of the logo in the button */
  logoSize?: number;

  /* The text of the button */
  text?: string;

  /* The text of the button (translation reference) */
  tx?: string;
};

/**
 * A button used in forms with a particular logo image (not standard icon).
 */
export const ExtraSignInButtonWithLogo = ({
  logo,
  logoSize = 15,
  text,
  tx,
  ...props
}: ExtraSignInButtonWithLogoProps) => {
  const { normalize } = useNormalize();

  return (
    <ExtraSignInButton {...props}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Image
          style={{ width: normalize(logoSize), height: normalize(logoSize) }}
          source={{
            uri: logo,
          }}
        />
        <Text
          style={{
            marginLeft: normalize(space.small),
            color: base_color.light_tertiary,
          }}
          tx={tx}
          text={text}
        />
      </View>
    </ExtraSignInButton>
  );
};
